import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Users_By_Id,
  gAPI_Property_List,
} from '../../../../../../constants/APIs';
import roleListData from '../../../../../../data/rolelist.json';

export default function EditUsersForm({
  formLabel,
  visible,
  toggle,
  id,
  submit,
}) {
  const [propertyList, setPropertyList] = useState([]);
  const [roleList, setRolesList] = useState([]);
  const [usersData, setUsersData] = useState({
    email: '',
    properties: ['-1'],
    roles: ['Admin'],
    creator: 'dashboard',
    firstName: '',
    lastName: '',
    phoneNumber: '',
  });

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${id}?gid=${getGroupID()}`,
    })
      .then((res) => {
        setUsersData(res.data);
        setRolesList(
          roleListData.data.map((elem) => {
            elem.checked = false;
            res.data.roles.forEach((r) => {
              if (r === elem.id) {
                elem.checked = true;
              }
            });
            return elem;
          })
        );
        AxiosAPI({
          method: 'get',
          url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
        })
          .then((res1) => {
            setPropertyList(
              res1.data.map((elem) => {
                elem.checked = false;
                res.data.properties.forEach((r) => {
                  if (r === elem.id) {
                    elem.checked = true;
                  }
                });
                return elem;
              })
            );
          })
          .catch((err) => console.error(err));
      })
      .catch((err) => console.log('err', err));
  }, [id]);

  const handleChange = (e) => {
    setUsersData({
      ...usersData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePropertiesChange = (e) => {
    const values = propertyList.map((elem) => {
      if (elem.id === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    setPropertyList(values);
  };

  const handleRoleChange = (e) => {
    const values = roleList.map((elem) => {
      if (elem.name === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    setRolesList(values);
  };

  useEffect(() => {
    const appPropertiesArr = propertyList
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.id);

    const appRolesArr = roleList
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.id);
    if (appPropertiesArr.length === 0) {
      appPropertiesArr.push('-1');
    }

    setUsersData({
      ...usersData,
      properties: appPropertiesArr,
      roles: appRolesArr,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyList, roleList]);

  const handleSubmit = () => {
    submit(usersData);
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          {/* <pre>{JSON.stringify(usersData, null, 2)}</pre> */}
          {usersData.firstName !== undefined ? (
            <Row className="mb-4">
              <Colxx xxs="12">
                <Row>
                  <Colxx sm={4} className="mb-3">
                    <Label>First Name</Label>
                    <Input
                      type="text"
                      onChange={handleChange}
                      name="firstName"
                      value={usersData.firstName}
                    />
                  </Colxx>
                  <Colxx sm={4} className="mb-3">
                    <Label>Last Name</Label>
                    <Input
                      type="text"
                      onChange={handleChange}
                      name="lastName"
                      value={usersData.lastName}
                    />
                  </Colxx>
                  <Colxx sm={4} className="mb-3">
                    <Label>Phone Number</Label>
                    <Input
                      type="text"
                      onChange={handleChange}
                      name="phoneNumber"
                      value={usersData.phoneNumber}
                    />
                  </Colxx>
                  <Colxx sm={4} className="mb-3">
                    <Label>Status</Label>
                    <Input
                      type="select"
                      value={usersData.status}
                      name="status"
                      onChange={handleChange}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </Input>
                  </Colxx>
                </Row>
                <h4>Roles & Businesses</h4>
                <Row>
                  <Colxx sm={4}>
                    <FormGroup>
                      <Label>Roles</Label>

                      {roleList.map((elem, index) => {
                        console.log(elem);
                    if(elem.name !=='Agent'){
                       return( <Fragment>
                        
                          <CustomInput
                            key={index}
                            type="checkbox"
                            value={elem.name}
                            id={elem.id}
                            onChange={handleRoleChange}
                            defaultChecked={elem.checked}
                          >
                            {elem.name === 'Admin'&&'Business Account (Admin)'}
                            {elem.name === 'User'&& 'Staff Account'}
                            {elem.name === 'View' && 'Vouchers Account'}
                          </CustomInput>
                             
                        </Fragment>); }}      
                      )}
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={4}>
                    <FormGroup>
                      <Label>Businesses</Label>
                      {propertyList.map((elem, index) => (
                        <CustomInput
                          key={index}
                          type="checkbox"
                          value={elem.id}
                          id={elem.id}
                          onChange={handlePropertiesChange}
                          defaultChecked={elem.checked}
                        >
                          {elem.name}
                        </CustomInput>
                      ))}
                    </FormGroup>
                  </Colxx>
                </Row>
              </Colxx>
            </Row>
          ) : (
            <div className="loading" />
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

EditUsersForm.propTypes = {
  // formLabel: PropTypes.string.isRequired,
  // visible: PropTypes.bool.isRequired,
  // toggle: PropTypes.func.isRequired,
  // updateRatePlansData: PropTypes.shape({
  //   name: PropTypes.array.isRequired,
  //   description: PropTypes.array.isRequired,
  //   conditions: PropTypes.array.isRequired,
  //   status: PropTypes.string.isRequired,
  // }),
  // applicableAddOnsWithIdAndName: PropTypes.array.isRequired,
  // includedAddOnsWithIdAndName: PropTypes.array.isRequired,
  // applicablePromosWithIdAndName: PropTypes.array.isRequired,
};
